import articleSellerFields from "./articleSellerFields";


export default `
  ${articleSellerFields}

  fragment articleFields on ArticleType {
    livesearchId
    id 
    user_product_id
    title 
    price
    currency
    catalogListing
    catalogProductId
    officialStoreId
    availableQuantity
    categoryId
    condition
    keyAttr
    bundle{
    type
    components{
    type
    user_product_id
    quantity
    }
    }
    attributes {
      id,
      valueName,
      name,
    }
    condVentas{
    id,
    price,
    currency,
    isCatalogo
    }
    variants
   similarCount
    tags
    href
    thumbnail
    siteId
    sellerId
    status
    images {
      id
      url
      secure_url
    } 
    seller { 
      ...articleSellerFields
    }
  seller_address {  
  country{
    id
    name
    }
  search_location {
    state {
      id
      name
    }
  }
}

    country {
      code 
      name
    }
    approved {
      author {
        id
        givenName
        familyName
      }
      createdAt
    }
    reported {
      tags {
        display
        active
      }
      code 
      description
      photosDenounced
      author {
        id
        givenName
        familyName
      }
      createdAt
      isFamily
      familyId
      evidence_id
      evidence_type
      design_registration_number
      design_protected_parts
      design_copied_parts
    }
    noticed {
      sent
      reason
      failed 
      sending
      noticeId
      noticedAt
      takeDownAt
    }
    originModel
  }
`;